module.exports = __webpack_public_path__ + "img/customer-thumbs.ae103b1f.png";